import type { FieldError as RHFFieldError } from 'react-hook-form';

interface FieldErrorProps {
  error: RHFFieldError | undefined;
}

export default function FieldError({ error }: FieldErrorProps): React.JSX.Element | null {
  if (!error?.message) return null;

  return (
    <span className="form-error" role="alert">
      {error.message}
    </span>
  );
}
